import {requiredIf, minValue, maxValue} from 'vuelidate/lib/validators';
import {
  NEW_USED_LIST,
  MAX_CAR_PRICE,
  MAX_ODOMETER,
  MIN_ODOMETER
} from '../../utils/constants';

const isUsed = (vm) => vm.vehicleCondition === NEW_USED_LIST.used.value;

export default {
  customerOptions: {
    carIsFrom: {
      required: requiredIf(isUsed)
    },
    odometer: {
      required: requiredIf(isUsed),
      minValue: minValue(MIN_ODOMETER),
      maxValue: maxValue(MAX_ODOMETER)
    },
    carPrice: {
      required: requiredIf(isUsed),
      minValue: minValue(0),
      maxValue: maxValue(MAX_CAR_PRICE)
    }
  },
  carIsFrom: ['customerOptions.carIsFrom'],
  odometer: ['customerOptions.odometer'],
  carPrice: ['customerOptions.carPrice']
};
